export default "__VITE_PUBLIC_ASSET__bd42f5df__"